import { SVGProps, Ref, forwardRef } from 'react';

export const PenOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.8 21.2v-3.525L14.1 6.374l3.526 3.525L6.326 21.2zM18.9 8.626l1.57-1.57a2.493 2.493 0 0 0-3.526-3.526l-1.57 1.57zM1 23v-6.071L15.672 2.257a4.293 4.293 0 0 1 6.07 6.071L7.072 23z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PenOutlinedSize24Glyph.displayName = 'PenOutlinedSize24Glyph';
